<my-modal #sentModal [theme]="'ls1'">
  <div modal-title>
    Borrower sent to Funding Desk
  </div>
  <div modal-body>
    <div class="row">
      <div class="col-sm-1">
        <i class="icon-30-validation-tick"></i>
      </div>
      <div class="col-sm-11">
        The funding desk has been notified that this borrower is ready for review. When doc prep is complete, you will
        receive a notification in your inbox.
      </div>
    </div>
  </div>
</my-modal>

<my-modal #errorModal [theme]="'ls1'">
  <div modal-title>
    {{ errorTitle }}
  </div>
  <div modal-body>
    <div class="error-icon">
      <i class="icon-30-red-x"></i>
    </div>
    <div class="error-body">
      {{ errorBody }}
    </div>
  </div>
</my-modal>

<app-collapsible-container
  name="appRequirements"
  [expanded]="expanded"
  *ngIf="((isVisible$ | async) && !sentToFundingDesk)"
>
  <h2
    bannerLeft
    class="mb-0"
    data-cy="appRequirements">
    Application Requirements
  </h2>
  <div mainContent>
    <div *ngIf="loading" style="display: flex; justify-content: center; padding: 20px;">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
    <div *ngIf="!loading">

      <!-- Progress Bar -->
      <div class="tw-pb-4 tw-pt-5">
        <progress-bar [percentComplete]="percentComplete" [hasWarning]="hasWarning"></progress-bar>
      </div>

      <!-- App Requirements -->
      <div [@fadeExpandInOut]>
        <div [@fadeExpandInOut] *ngFor="let valueRequirement of appRequirements.valueRequirements; trackBy: reqTrackId">
          <app-requirement-collapse
            [borrowerId]="borrowerId"
            [appRequirement]="valueRequirement"
            [viewState]="viewState"
            (ignored)="handleIgnoreEvent($event)">
          </app-requirement-collapse>
        </div>
      </div>

      <!-- Bank Requirements -->
      <div [@fadeExpandInOut] *ngIf="showBankRequirement">
        <app-requirement-collapse
          [borrowerId]="borrowerId"
          [bankRequirementStatus]="appRequirements.bankStatementRequirement.status"
          [bankRequirements]="appRequirements.bankStatementRequirement.months"
          [viewState]="viewState"
          (met)="onBankRequirementMet()">
        </app-requirement-collapse>
      </div>

      <div class="my-3 text-center gray-600">{{ requirementsStatusMessage }}</div>

      <!-- Buttons -->
      <div id="appRequirementButtons"
           class="d-flex justify-content-end pt-0 pb-3 "
           [ngClass]="{ 'pb-4': ignoredRequirements && ignoredRequirements.length > 0 }">
        <submit-app-button
          [onAppReqPanel]="true"
          [borrowerId]="borrowerId"
          [disabled]="!(((isValid$ | async) && !(sentToFundingDesk$ | async)) || (canOverrideAppReqs$ | async))"
          (submitted)="submitted($event)">
        </submit-app-button>
      </div>

      <!-- Separator For Ignored Requirements -->
      <div class="border-bottom border-gray-300" *ngIf="ignoredRequirements && ignoredRequirements.length > 0"></div>

      <!-- Ignored Requirements -->
      <div class="tw-py-3" *ngIf="ignoredRequirements && ignoredRequirements.length > 0">
        <div class="col-12 px-0 py-0 d-flex animate-color"
             [ngClass]="{ 'gray-600': !ignoredExpanded }"
             style="cursor: pointer;"
             (click)="toggleExpandedIgnored()">
          <div class="pr-2">
            <i class="fa fa-angle-down animate-rotation" [ngClass]="{'rotate-180': ignoredExpanded}"></i>
          </div>
          <div>
            Ignored ( {{ ignoredRequirements.length }} )
          </div>
        </div>

        <div *ngIf="ignoredExpanded" [@expandInOut]>
          <div class="pl-4 pt-2">
            <div *ngFor="let valueRequirement of ignoredRequirements; trackBy: reqTrackId">
              <app-requirement-collapse
                [borrowerId]="borrowerId"
                [appRequirement]="valueRequirement"
                [viewState]="viewState"
                (ignored)="handleIgnoreEvent($event)">
              </app-requirement-collapse>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</app-collapsible-container>
